
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"reportDocument"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportDocument"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"personType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"personKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"trilliumTotalRentPaid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rentersCreditTotalRentPaid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telecommutingNumberOfDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"teacherSchoolSupplyAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medicalFeesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"donationsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"movingExpensesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incomeOutsideCanadaAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"providedDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"providedDocumentUrls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"providedMissingInfos"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"explanationInitialMissingDocs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"missingDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasSubmittedWithMissingDocs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasSubmittedWithMissingDocsAfterPurchase"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"missingInfosDocsSubmittedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated_at"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":507}};
    doc.loc.source = {"body":"fragment reportDocument on ReportDocument {\n  id\n  personType\n  personKey\n  trilliumTotalRentPaid\n  rentersCreditTotalRentPaid\n  telecommutingNumberOfDays\n  teacherSchoolSupplyAmount\n  medicalFeesAmount\n  donationsAmount\n  movingExpensesAmount\n  incomeOutsideCanadaAmount\n  providedDocuments\n  providedDocumentUrls\n  providedMissingInfos\n  explanationInitialMissingDocs\n  missingDocuments\n  hasSubmittedWithMissingDocs\n  hasSubmittedWithMissingDocsAfterPurchase\n  missingInfosDocsSubmittedAt\n  updated_at\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["reportDocument"] = oneQuery(doc, "reportDocument");
        
